import { Navigate, useLocation } from 'react-router-dom';
import pagesRoutes from 'app/views/pages/PagesRoutes';
import { hasPermission } from 'app/utils/permissions';

const AuthGuard = ({ children }) => {
  const { pathname } = useLocation();
  const token = localStorage.getItem('TOKEN');

  if (!token) {
    return <Navigate replace to="/session/signin" state={{ from: pathname }} />;
  }

  const role = localStorage.getItem('USER_ROLE');
  if (role === 'super_admin') {
    return children;
  }

  const matched = pagesRoutes.find((r) => r.path === pathname);
  const fallbackPath = '/pages/branch-dashboard';
  const featureCodes = matched?.featureCode
    ? Array.isArray(matched.featureCode)
      ? matched.featureCode
      : [matched.featureCode]
    : [];
  const hasAccess = featureCodes.length === 0 || featureCodes.some((code) => hasPermission(code, 'view_only'));
  if (!hasAccess && pathname !== fallbackPath) {
    return <Navigate replace to={fallbackPath} />;
  }

  return children;
};

export default AuthGuard;
